/**
 * Platform Detection Utilities
 * Detect iOS, Android, mobile vs desktop for platform-specific audio handling
 */

/**
 * Detect if running on iOS (iPhone, iPad, iPod)
 * Used to bypass Blob URLs which have issues on iOS with WAV files
 */
export const isIOS = (): boolean => {
  if (typeof navigator === "undefined") return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

/**
 * Detect if running on Android
 */
export const isAndroid = (): boolean => {
  if (typeof navigator === "undefined") return false;
  return /Android/.test(navigator.userAgent);
};

/**
 * Detect if running on mobile device (iOS or Android)
 */
export const isMobile = (): boolean => {
  if (typeof navigator === "undefined") return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

/**
 * Detect if running on desktop (not mobile)
 */
export const isDesktop = (): boolean => {
  return !isMobile();
};
